import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#E95BBB',
      light: '#FDEFF9',
    },
    text: {
      primary: '#111111',
      secondary: '#3F3F3F',
    },
    secondary: {
      main: '#F5F5F5',
      light: '#777777',
    },
    info: {
      main: '#666666',
    },
  },
});

export default theme;
